<script lang="ts" setup>
import type {ComponentLayoutTextVideo} from '~~/types/strapi-blog';

const props = defineProps<ComponentLayoutTextVideo>();

const sectionOrientation = computed(() => props.orientation ?? 'vertical')
const sectionReverse = computed(() => props.reverseOrder ?? false)
const strapiVideoUrl = computed(() =>
    props.video?.url ? useStrapiMedia(props.video.url) : null
)

const nodes = computed(() => Array.isArray(props.videoTextContent) ? props.videoTextContent : [])

const sectionUi = computed(() => ({
    container: props.description
        ? 'sm:gap-8'
        : 'sm:gap-16 py-8 sm:py-8 lg:py-8 gap-16 sm:gap-8',
}))
</script>

<template>
    <UPageSection
        :orientation="sectionOrientation"
        :reverse="sectionReverse"
        :ui="sectionUi"
        class="lg:first:pt-12"
    >
        <template #body>
            <div
                v-if="nodes.length"
                class="flex flex-col"
            >
                <slot name="title">
                    <h2
                        v-if="props.title"
                    >
                        {{ props.title }}
                    </h2>
                </slot>
                <slot name="description">
                    <p
                        v-if="props.description"
                        class="font-bold"
                    >
                        {{ props.description }}
                    </p>
                </slot>
                <div
                >
                    <StrapiBlocksText :nodes="nodes"/>
                </div>
            </div>
        </template>
        <template #default>
            <div
                v-if="strapiVideoUrl"
            >
                <video
                    :aria-description="props.description || undefined"
                    :aria-label="props.title || 'Embedded video'"
                    :src="strapiVideoUrl"
                    controls
                    controlslist="nodownload"
                />
            </div>
        </template>
    </UPageSection>
</template>
